import React, { useCallback, useEffect, useState } from 'react';

import {
  getPharmacyBilling,
  paymentActions,
  PharmacyBillingPageStatuses,
  pharmacyBillingSelector,
  resetStatus,
  successOrSelector,
} from '@pharmaplan/common';

import { showSuccess } from '../../../Admin/Profile/Pharmacist/PharmacistViewProfile/helper';
import { useAppDispatch } from '../../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import strings from '../../../../localization';

import ExistingPaymentPlan from './ExistingPaymentPlan';
import GetPayment from './GetPayment';
import ViewPlans from './ViewPlans';
import UpgradePlan from './UpgradePlan';

const { payment, existingPaymentPlan, showPaymentPlans, upgradePlan } = PharmacyBillingPageStatuses;
const { cancelSubscription, resumeSubscription } = paymentActions;

const PharmacyBilling = () => {
  const dispatch = useAppDispatch();
  const billing = useAppSelector(pharmacyBillingSelector);
  const cancelSubscriptionSuccess = useAppSelector((state) =>
    successOrSelector([cancelSubscription, resumeSubscription], state));

  const [pageStatus, setPageStatus] = useState(existingPaymentPlan);

  useEffect(() => {
    if (billing?.creditCardLast4) {
      setPageStatus(existingPaymentPlan);
    } else {
      setPageStatus(payment);
    }
  }, [billing.creditCardLast4]);

  const Screen = useCallback(() => {
    switch (pageStatus) {
      case payment:
        return <GetPayment />;
      case existingPaymentPlan:
        return <ExistingPaymentPlan setPageStatus={setPageStatus} />;
      case showPaymentPlans:
        return <ViewPlans setPageStatus={setPageStatus} />;
      case upgradePlan:
        return <UpgradePlan setPageStatus={setPageStatus} />;
      default:
        return <GetPayment />;
    }
  }, [pageStatus]);

  useEffect(() => {
    dispatch(getPharmacyBilling());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (cancelSubscriptionSuccess) {
      showSuccess(dispatch, strings.actionCompletedSuccessfully);
      dispatch(getPharmacyBilling());
      setPageStatus(PharmacyBillingPageStatuses.existingPaymentPlan);
      dispatch(resetStatus([cancelSubscription, resumeSubscription]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cancelSubscriptionSuccess]);

  return <Screen />;
};

export default PharmacyBilling;
